import React from 'react'

import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled'
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled'
import { IconButton } from '@mui/material'

// IconButton is rendered with a non-standard `isActive` prop; cast to preserve behaviour.
const StatusIconButton = IconButton as any

type CampaignAdActionButtonProps = {
  ad: {
    id: number
    is_running: boolean
    type: string
  }
  onStatusChange: (...args: any[]) => any
}

const CampaignAdActionButton = ({ ad, onStatusChange }: CampaignAdActionButtonProps) => {
  const { is_running, id, type } = ad

  const toggleStatus = () => onStatusChange({ id, type, is_running: !is_running })

  return (
    <StatusIconButton
      aria-label={is_running ? 'Pause' : 'Resume'}
      color={is_running ? 'primary' : 'secondary'}
      isActive={is_running}
      onClick={toggleStatus}
      title={is_running ? 'Pause' : 'Resume'}>
      {is_running ? <PauseCircleFilledIcon /> : <PlayCircleFilledIcon />}
    </StatusIconButton>
  )
}

export default CampaignAdActionButton
